import { AppointmentRecord } from "~/api/API";
import { excludeBillingReceiptsFilter } from "~/api/queries/useAppointmentFiles";
import { useResolvedLinkedFiles } from "~/api/queries/useResolvedLinkedFiles";

/**
 * Hook for the Upload Tab that fetches files from all linked appointments
 * and resolves ownership based on reschedule chain logic.
 *
 * - In a reschedule chain (A→B→C): the latest active appointment owns files as "current",
 *   except for pinned file types (e.g. Notice 110) which stay with the original uploader.
 * - For reevals/supplementals/depositions: inherited files are read-only.
 * - Billing receipts are excluded (same as the existing Upload Tab behavior).
 *
 * Thin wrapper over `useResolvedLinkedFiles` with the billing-receipt filter.
 */
export function useUploadTabLinkedFiles(
  appointment: AppointmentRecord | null | undefined,
) {
  return useResolvedLinkedFiles(appointment, {
    select: excludeBillingReceiptsFilter,
  });
}
